<template>
    <div id="top">
        <component :is="'script'" type="application/ld+json" v-html="eventsJsonLd" />
        <div class="d-flex align-items-center justify-content-center pt-3">
            <div class="d-flex align-items-center text-start text-white px-5">
                <h1 class="text-uppercase text-black display-header home-text mx-2 text-center">Shows</h1>
            </div>
        </div>
        <div class="container pt-2">
            <div class="mx-auto text-center" style="max-width: 1000px;">
                Our main company performs two shows every Friday and Saturday night at our theater. <a
                    class="contact-link" href="/Contact">Click here</a> for
                directions and information on where to park. Tickets for our regular shows cost $11, $7 for students,
                educators and veterans,
                and can be purchased online or at the door.
            </div>
        </div>
        <div class="shows-btn-group pt-5 pb-5 px-4">
            <a :href="`${$TICKETS_URL}`" class="shows-btn-link">
                <div class="btn dark-btn text-uppercase mb-5 text-white w-100" type="button">Buy Tickets</div>
            </a>
            <a href="#plan-your-trip" class="shows-btn-link">
                <div class="btn text-uppercase mb-5 text-white w-100" style="background-color: var(--atlas-red);"
                    type="button">Plan Your Trip</div>
            </a>
        </div>
        <div id="shows" class="bg-dark w-100 mb-5" style="height: 2px;"></div>

        <transition name="page-fade">
            <div v-if="showsReady">
                <AllShows :showsData="showsData" />
                <PageSections :sectionId="2" />

                <!-- Plan Your Trip Section -->
                <div id="plan-your-trip" class="plan-trip-section position-relative overflow-hidden">
                    <div class="plan-trip-stripes position-absolute w-100 h-100" style="top:0;left:0;"></div>
                    <div class="position-relative" style="z-index:2;">
                        <div class="px-4 px-lg-5 pt-5 text-center">
                            <div class="text-uppercase oswald-bold text-white mb-4"
                                style="font-size: clamp(2rem, 5vw, 3.5rem); letter-spacing: 2px; text-shadow: 0 2px 12px rgba(0,0,0,0.9), 0 0 30px rgba(0,0,0,0.7);">
                                Plan Your Trip</div>
                        </div>
                        <div class="row g-0 align-items-start px-4 px-lg-5 pb-5">
                            <!-- Left: performers image -->
                            <div class="col-12 col-xl-5 d-flex align-items-start justify-content-center pb-4 pb-xl-0"
                                ref="planImage">
                                <img src="@/assets/GROUP.png" class="plan-trip-image-side"
                                    :class="{ 'plan-image-visible': planImageVisible }" alt="Atlas Improv performers" />
                            </div>
                            <!-- Right: cards -->
                            <div class="col-12 col-xl-7 ps-xl-5">
                                <div class="plan-cards-grid" ref="planCardsGrid">
                                    <div v-for="(step, index) in tripSteps" :key="step.title" class="plan-card-wrap"
                                        :class="{ 'plan-card-visible': planCardsVisible }"
                                        :style="{ '--card-index': index }">
                                        <div class="plan-card d-flex flex-column"
                                            :style="{ borderLeftColor: step.color, borderRightColor: step.color, borderBottomColor: step.color }">
                                            <div class="d-flex justify-content-between align-items-start mb-3">
                                                <span class="text-uppercase oswald-bold"
                                                    style="font-size: 1.45rem; letter-spacing: 1px;"
                                                    :style="{ color: step.color }">{{ step.title }}</span>
                                                <i :class="step.icon" :style="{ color: step.color }"
                                                    style="font-size: 1.25rem; margin-left: 8px; flex-shrink: 0; margin-top: 2px;"></i>
                                            </div>
                                            <p
                                                style="font-size: 1rem; color: #ddd; flex-grow: 1; margin-bottom: 1rem; line-height: 1.6;">
                                                {{ step.description }}</p>
                                            <div v-if="step.buttons && step.buttons.length"
                                                class="d-flex flex-wrap gap-2 mt-auto">
                                                <template v-for="btn in step.buttons" :key="btn.text">
                                                    <button v-if="btn.modal" @click="btn.modal()" class="plan-btn"
                                                        :style="{ backgroundColor: step.color }">
                                                        <i v-if="btn.icon" :class="btn.icon" class="me-1"
                                                            style="font-size: 0.85rem;"></i>{{ btn.text }}
                                                    </button>
                                                    <a v-else :href="btn.href" class="plan-btn"
                                                        :style="{ backgroundColor: step.color }">
                                                        <i v-if="btn.icon" :class="btn.icon" class="me-1"
                                                            style="font-size: 0.85rem;"></i>{{ btn.text }}
                                                    </a>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="plan-trip-divider"></div>
                </div>

                <!-- <div class="container-fluid" style="background-color: black;">
         <div class="row chalk-row">
             <div class="col-md-6 offset-md-3 d-flex flex-column align-items-center justify-content-center">
                 <div class="text-center chalk-outline">
                     <div class="fs-1 text-uppercase text-white"> Take a Class</div>
                     <div class="fs-1 text-uppercase text-white"> With atlas improv</div>
                 </div>
                 <div class="text-white text-center">Atlas Improv's philosophy emphasizes character-based
                     storytelling, and, through our classes, we pass it on to our students. Besides being fun,
                     comprehensive, diverse and dynamic, our classes also build confidence, teamwork, leadership and
                     decision-making skills.</div>
                 <div class="text-white py-3 p text-center"> Every Fall, Spring, and Summer Semester, we typically
                     offer improv Core Class, Advanced Short-form and Long-form classes.</div>
                 <div class="pt-5">
                     <div class="btn ms-2 text-uppercase text-white chalk-btn "
                         style="background-color: #1A95AC; border-radius: 0;" type="button">Learn More</div>
                     <div class="btn ms-2 text-uppercase text-white chalk-btn  "
                         style="background-color: #1A95AC; border-radius: 0;" type="button">Register</div>
                 </div>

             </div>

         </div>

     </div>
     <div class="container-fluid" style="background-color:rgb(246,206,55);">
         <div class="row flex-row-reverse">
             <div class="col-md-6">
                 <div class="our-story">
                     <div class='h1 text-uppercase'> Our Story</div>
                     <div class="py-3">Atlas Improv was founded in early 2004 by Mary Parmentier and Bryan Judkins.
                         Their dream was to explore and innovate beyond what was familiar. As managers Parmentier and
                         Judkins sought a creative environment that challenged and fulfilled us artistically. They
                         knew we were capable of more and wanted to push us to new heights. They realized short-form
                         wasn’t enough. In 2004, they Started Atlas Improv. The active mebers of ComedySportz -
                         Madison followed Parmentier to do something new and amazing.</div>
                     <div class="py-3">Today Atlas Improv fosters an expert in each of its players. In story arc,
                         character building, or pure wite, every performer is a master.</div>
                     <div class="btn text-uppercase text-white chalk-btn my-5 orange-back " type="button">Learn More
                     </div>
                 </div>
             </div>
             <div class="col-md-6">
                 <img :src="`${$API_ASSETS}4b23b7c6-fb4b-44cd-bb1f-f52b097724eb.png`"
                     class="img-fluid w-100 d-md-inline" alt="globe" />
             </div>
         </div>

     </div> -->


                <div class="container-fluid position-relative pt-2 site-black-bg overflow-hidden" ref="otherPerformancesSection">
                    <div class="position-relative" style="padding: 0; margin: 0;">
                        <div class="text-overlay w-100 position-absolute" style="top: 20%; left: 0; padding-left: 10%; z-index: 2;">
                            <div class="col-lg-4 text-white text-start">
                                <div class="text-uppercase display-4 oswald-bold pb-2">Other performances</div>
                                <div class="pb-3">
                                    We at Atlas love sharing our stage with others. We regularly host Atlas Indie Teams
                                    as part
                                    of our 9pm shows. We have also hosted a number of local improvisers and comedians as
                                    well as
                                    visiting improvisers from out-of-town.
                                </div>
                                <div>
                                    To see if we've got any of these special shows coming up, be sure to check out all
                                    our
                                    social media. If you're an improviser who will be visiting the area and would like
                                    to know
                                    more about performing on our stage or hosting a workshop, please email
                                    info@atlasimprov.com
                                </div>
                            </div>
                        </div>
                        <picture>
                            <source srcset="@/assets/Schoom-mobile.png" media="(max-width: 767px)" />
                            <img :src="require('@/assets/Schoom_cropped.jpeg')"
                                class="img-fluid w-100 other-perf-img"
                                :class="{ 'other-perf-img-visible': otherPerformancesVisible }"
                                style="display: block; margin: 0; padding: 0;" />
                        </picture>
                    </div>
                </div>

                <Footer />
            </div>
        </transition>

        <!-- Parking Map Modal -->
        <transition name="md-superscale">
        <div v-if="showParkingMap" class="parking-modal-overlay" @click.self="showParkingMap = false">
            <div class="parking-modal-inner">
                <button class="parking-modal-close" @click="showParkingMap = false">&times;</button>
                <img :src="`${$API_ASSETS}9575146c-0de7-462b-bcde-040e373996b1.png`" class="img-fluid"
                    alt="Parking Map" />
            </div>
        </div>
        </transition>

    </div>



</template>

<script>
import PageSections from '@/components/PageSections.vue';
import AllShows from '../components/AllShows.vue';
import Footer from '../components/Footer.vue';
import axios from 'axios';
import { useRoute } from 'vue-router';
import { useHead } from '@unhead/vue';


export default {
    name: 'Shows',
    components: {
        Footer, AllShows, PageSections
    },
    data() {
        return {
            showsData: [],
            showsReady: false,
            planCardsVisible: false,
            planImageVisible: false,
            otherPerformancesVisible: false,
            showParkingMap: false,
            tripSteps: [
                {
                    title: 'Get Your Tickets',
                    description: 'Shows happen every Friday and Saturday night. Tickets are $11 general admission, $7 for students, educators, and veterans. Purchase online in advance or at the door.',
                    color: '#1994AC',
                    icon: 'fas fa-ticket-alt',
                    buttons: [
                        { text: 'Buy Tickets', href: this.$TICKETS_URL, icon: 'fas fa-ticket-alt' },
                        { text: 'View Shows', href: '#shows', icon: 'fas fa-arrow-up' }
                    ]
                },
                {
                    title: 'Find Us',
                    description: 'Atlas Improv is located at 609 East Washington Ave, Madison, WI.',
                    color: '#D8BA60',
                    icon: 'fas fa-map-marker-alt',
                    buttons: [{ text: 'Get Directions', href: 'https://www.google.com/maps?q=609+E+Washington+Ave+Madison,+WI+53703', icon: 'fas fa-map-marker-alt' }]
                },
                {
                    title: 'Parking',
                    description: 'Parking is available in the MGE Good Neighbor lots at 640 E. Main St. and 1600 Railroad St., and the lot at 665 E. Washington Ave. next to The Brass Ring. Street parking is also available on Blount and Main Streets.',
                    color: '#D75948',
                    icon: 'fas fa-parking',
                    buttons: [{ text: 'Parking Map', icon: 'fas fa-map', modal: () => { this.showParkingMap = true; } }]
                },
                {
                    title: 'Get a Bite',
                    description: "We recommend grabbing dinner before the show! Atlas doesn't serve food, but there are several great local restaurants within walking distance.",
                    color: '#017B4A',
                    icon: 'fas fa-utensils',
                    buttons: [
                        { text: '5 Star Korean BBQ', href: 'https://5starkoreanbbq.com/', icon: 'fas fa-external-link-alt' },
                        { text: 'The Brass Ring', href: 'https://www.thebrassringmadison.com/', icon: 'fas fa-external-link-alt' },
                        { text: 'Señor Machete\'s', href: 'https://senormachetes.com/', icon: 'fas fa-external-link-alt' }
                    ]
                },
                {
                    title: 'Arrive Early',
                    description: 'Doors open before showtime — plan to arrive a few minutes early to get settled. Our box office is open 30 minutes before the show.',
                    color: '#BB4A8C',
                    icon: 'fas fa-clock',
                    buttons: []
                },
                {
                    title: 'Enjoy the Show',
                    description: "Each show runs roughly 60–90 minutes. Our performers do it all live — no scripts, no net. Audience participation is welcome but never required.",
                    color: '#1994AC',
                    icon: 'fas fa-theater-masks',
                    buttons: []
                },
            ]
        };
    },
    computed: {
        eventsJsonLd() {
            const upcoming = (this.showsData || []).filter(s => !s.previous_show);
            const events = upcoming.map(s => ({
                "@type": "Event",
                "name": s.name,
                "description": s.description || s.name,
                "image": s.banner_image
                    ? `${this.$API_ASSETS}${s.banner_image.id}?width=1200`
                    : "https://atlasimprov.com/social_card_1200x630.png",
                "url": s.fw_link || "https://atlasimprov.com/shows",
                "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
                "eventStatus": "https://schema.org/EventScheduled",
                "performer": {
                    "@type": "PerformingGroup",
                    "name": "Atlas Improv Co."
                },
                "location": {
                    "@type": "Place",
                    "name": "Atlas Improv Co.",
                    "address": {
                        "@type": "PostalAddress",
                        "streetAddress": "609 E Washington Ave",
                        "addressLocality": "Madison",
                        "addressRegion": "WI",
                        "postalCode": "53703",
                        "addressCountry": "US"
                    }
                },
                "offers": s.fw_link ? {
                    "@type": "Offer",
                    "url": s.fw_link,
                    "price": "11",
                    "priceCurrency": "USD",
                    "availability": "https://schema.org/InStock"
                } : undefined
            }));
            return JSON.stringify({
                "@context": "https://schema.org",
                "@graph": events
            });
        }
    },
    methods: {
        async fetchShowsData() {
            const url = this.$API_GRAPHQL;
            try {
                const response = await axios.post(url, {
                    query: `
                      query {
                        show {
                          id
                          name
                          date_text
                          family_friendly
                          description
                          fw_link
                          regular_show
                          previous_show
                          pay_what_you_can
                          learn_more
                          banner_image { id }
                        }
                      }
                    `
                }, {
                    headers: {
                        'Authorization': `Bearer Pm4Nd5_e46HaK2xtkPcla2PMBzbk9AQf`,
                        'Content-Type': 'application/json'
                    }
                });

                this.showsData = response.data.data.show || [];

                const visibleShows = this.showsData.filter(s => !s.previous_show);
                await Promise.all(visibleShows.map(s => new Promise(resolve => {
                    const img = new Image();
                    img.onload = img.onerror = resolve;
                    img.src = `${this.$API_ASSETS}${s.banner_image.id}?width=800&quality=80`;
                })));

                this.showsReady = true;
            } catch (error) {
                console.error('Error fetching shows:', error);
                this.showsReady = true;
            }
        }
    },
    beforeUnmount() {
        if (this._planObserver) this._planObserver.disconnect();
        if (this._imageObserver) this._imageObserver.disconnect();
        if (this._otherPerfObserver) this._otherPerfObserver.disconnect();
    },
    watch: {
        showsReady(val) {
            if (!val) return;
            this.$nextTick(() => {
                const target = this.$refs.planCardsGrid;
                if (target) {
                    this._planObserver = new IntersectionObserver((entries) => {
                        if (entries[0].isIntersecting) {
                            this.planCardsVisible = true;
                            this._planObserver.disconnect();
                        }
                    }, { threshold: 0 });
                    this._planObserver.observe(target);
                }

                const imgTarget = this.$refs.planImage;
                if (imgTarget) {
                    this._imageObserver = new IntersectionObserver((entries) => {
                        if (entries[0].isIntersecting) {
                            this.planImageVisible = true;
                            this._imageObserver.disconnect();
                        }
                    }, { threshold: 0 });
                    this._imageObserver.observe(imgTarget);
                }

                const otherPerfTarget = this.$refs.otherPerformancesSection;
                if (otherPerfTarget) {
                    let initialized = false;
                    setTimeout(() => { initialized = true; }, 200);
                    this._otherPerfObserver = new IntersectionObserver((entries) => {
                        if (initialized && entries[0].isIntersecting) {
                            this.otherPerformancesVisible = true;
                            this._otherPerfObserver.disconnect();
                        }
                    }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });
                    this._otherPerfObserver.observe(otherPerfTarget);
                }
            });
        }
    },
    created() {
        this.fetchShowsData();
    },
    setup() {
        const route = useRoute();
        useHead({
            title: route.meta.title || 'Atlas Improv – Shows',
            meta: [
                {
                    name: 'description',
                    content: route.meta.description || 'See upcoming improv shows and buy tickets at Atlas Improv in Madison.'
                }
            ]
        });
        return {};
    },
};
</script>

<style scoped>
.page-fade-enter-active {
    transition: opacity 0.6s ease;
}

.page-fade-enter-from {
    opacity: 0;
}

.shows-btn-group {
    display: flex;
    justify-content: center;
    gap: 1rem;
}

.shows-btn-link {
    min-width: 180px;
}

@media (max-width: 575px) {
    .shows-btn-link {
        min-width: unset;
        flex: 1;
    }

    .shows-btn-link .btn {
        font-size: 0.7rem;
        padding: 0.375rem 0.5rem;
        width: 100%;
    }
}

@media (max-width: 1024px) {
    .text-overlay {
        position: static !important;
        padding: 3rem 2rem;
        margin-bottom: 2rem;
    }
}

/* Plan Your Trip */
.plan-trip-section {
    background-color: var(--site-black);
}

.plan-trip-divider {
    height: 2px;
    width: 100%;
    position: relative;
    z-index: 3;
    background-color: white;
}

.plan-trip-stripes {
    background: repeating-linear-gradient(45deg,
            transparent 0, transparent 45px,
            var(--atlas-green) 45px, var(--atlas-green) 55px,
            transparent 55px, transparent 100px,
            var(--atlas-blue) 100px, var(--atlas-blue) 108px,
            transparent 108px, transparent 155px,
            var(--atlas-yellow) 155px, var(--atlas-yellow) 167px,
            transparent 167px, transparent 210px,
            var(--atlas-orange) 210px, var(--atlas-orange) 220px,
            transparent 220px, transparent 265px,
            var(--atlas-magenta) 265px, var(--atlas-magenta) 273px,
            transparent 273px, transparent 318px,
            var(--atlas-red) 318px, var(--atlas-red) 325px,
            transparent 325px, transparent 370px,
            var(--atlas-blue) 370px, var(--atlas-blue) 376px,
            transparent 376px, transparent 420px,
            var(--atlas-green) 420px, var(--atlas-green) 432px);
    opacity: 0.5;
}

.plan-cards-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-auto-rows: 1fr;
    gap: 1.5rem;
}

@media (max-width: 575px) {
    .plan-cards-grid {
        grid-template-columns: 1fr;
        gap: 1rem;
    }

    .plan-cards-grid>div:nth-child(even) .plan-card {
        border-left: none;
        border-right-width: 3px;
        border-right-style: solid;
    }

    .plan-cards-grid .plan-card {
        padding-bottom: 1.4rem;
    }
}

.plan-card-wrap {
    opacity: 0;
    transform: translateY(24px);
    transition: opacity 0.5s ease, transform 0.5s ease;
    transition-delay: calc(var(--card-index) * 0.1s);
}

.plan-card-wrap.plan-card-visible {
    opacity: 1;
    transform: translateY(0);
}

.plan-card {
    height: 100%;
    background-color: rgba(15, 15, 15, 0.82);
    border-left: 3px solid;
    padding: 1.5rem 1.4rem;
}

.plan-card p {
    font-family: 'Open Sans', sans-serif;
}

.plan-btn {
    display: inline-flex;
    align-items: center;
    padding: 7px 18px;
    font-size: 0.88rem;
    font-weight: 700;
    font-family: 'Work Sans', sans-serif;
    text-transform: uppercase;
    color: white !important;
    text-decoration: none;
    letter-spacing: 0.5px;
    border-radius: 2px;
    white-space: nowrap;
}

.plan-btn:hover {
    opacity: 0.8;
}

.plan-trip-image-side {
    max-height: 680px;
    width: 100%;
    margin-top: -2rem;
    object-fit: contain;
    opacity: 0;
    transform: translateX(-48px);
    transition: opacity 1.0s ease, transform 1.0s ease;
}

.plan-trip-image-side.plan-image-visible {
    opacity: 1;
    transform: translateX(0);
}

/* Tablet: image stacks above cards — constrain so it doesn't span full width */
@media (min-width: 576px) and (max-width: 1199px) {
    .plan-trip-image-side {
        max-width: 50%;
        max-height: 420px;
    }
}

@media (min-width: 1200px) {
    .plan-trip-image-side {
        max-height: 860px;
    }
}

.other-perf-img {
    transform: translateX(80px);
    opacity: 0;
    transition: transform 1.5s ease, opacity 1.5s ease;
}

.other-perf-img.other-perf-img-visible {
    transform: translateX(0);
    opacity: 1;
}

.parking-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.85);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1.5rem;
}

.parking-modal-inner {
    position: relative;
    max-width: 800px;
    width: 100%;
}

.parking-modal-close {
    position: absolute;
    top: -1rem;
    right: -1rem;
    background: var(--atlas-magenta);
    color: white;
    border: none;
    border-radius: 50%;
    width: 2rem;
    height: 2rem;
    font-size: 1.2rem;
    line-height: 1;
    cursor: pointer;
    z-index: 1;
}

/* "Super Scaled" modal animation (matches the WhatToExpect modals):
   overlay fades while the panel zooms from 2x down to normal — reverses on close. */
.md-superscale-enter-active,
.md-superscale-leave-active {
    transition: opacity 0.45s ease;
}

.md-superscale-enter-active .parking-modal-inner,
.md-superscale-leave-active .parking-modal-inner {
    transition: transform 0.45s ease, opacity 0.45s ease;
}

.md-superscale-enter-from,
.md-superscale-leave-to {
    opacity: 0;
}

.md-superscale-enter-from .parking-modal-inner,
.md-superscale-leave-to .parking-modal-inner {
    transform: scale(2);
    opacity: 0;
}
</style>
